import * as S from "./UserSideMenuList.style";
import { LoginType } from "@/common/states/user";
import { UserSideMenuItem } from "@/components/atoms/UserSideMenuItem";

interface UserSideMenuListProps {
  data: any;
  loginType: LoginType;
}

export const UserSideMenuList = ({
  data,
  loginType,
}: UserSideMenuListProps) => {
  return (
    <S.UserSideMenuList>
      {data
        .filter((item: any) => {
          return !item.type || item.type === loginType;
        })
        .map((item: any, idx: number) => {
          return <UserSideMenuItem item={item} key={idx} />;
        })}
    </S.UserSideMenuList>
  );
};
